import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from '../../utils/googleAuth';

/**
 * Mounts Google Identity Services, and only where someone can actually sign in.
 *
 * GoogleOAuthProvider injects accounts.google.com/gsi/client as soon as it
 * mounts. It used to sit at the root of the tree in index.tsx, so every visitor
 * to the marketing site downloaded, parsed and ran Google's sign-in library on
 * a page with no sign-in on it. PageSpeed charged it as a long main-thread task
 * of its own, on top of a third-party connection and parse, during the window
 * where the landing page is trying to paint.
 *
 * Three pages need it: Login, Register and GetStarted. They are lazy routes, so
 * scoping the provider to them means the script is fetched when one of them is
 * opened and never before.
 *
 * It must stay ABOVE anything calling useGoogleOAuth, which throws outside a
 * provider. That is useGoogleSignInAvailable and <GoogleLogin>, both of which
 * live inside these three pages.
 */
export const GoogleSignInScope: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>{children}</GoogleOAuthProvider>
);

export default GoogleSignInScope;
